/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".arrow[_ngcontent-%COMP%]{position:relative;right:15px;width:30px;height:30px;border:7px solid;border-color:rgb(var(--sc-color-primary)) transparent transparent rgb(var(--sc-color-primary));transform:rotate(-45deg);-webkit-animation:2s linear infinite slide;animation:2s linear infinite slide}@-webkit-keyframes slide{0%,100%{right:15px}50%{right:-15px}}@keyframes slide{0%,100%{right:15px}50%{right:-15px}}"];
export { styles as styles };
